import React, {useState, useEffect, Button} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';

import { facilityActions,facilitySlotActions,locationActions,paketinActions, useSelector } from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react

import Notification from "./Notification";
import ImageUpload from "../../../components/ImageUpload";
import FormItem from "../../../components/FormItem";
import {_exchangeLabel} from "../../../../utils/Helper";
import {createLock} from "inbooma-api/store/paketins/actions";

const FacilityView = (props) => {
    const [facility,setFacility] = useState(typeof props.facility.id === 'undefined' ? {            // make a local copy of task or initialize a new task
        location_id: '',
        client_id: Biscuit.get('user.client_id'),
        status: 'active',
        name: '',
        description: '',
        facility_type: 'cyclepoint',
        booking_type: 'none',
        roles: 'admin,manager,manager-location,booking-manager,garage-staff,guide,mediator,facility-service,user',
        error_code: '',
        error_text: '',
        image: '',
        hash: null,
        autoCheckout: false,
        checkoutOutOfSlotPossible: false,
        external_id: null,
        facility_slots: [],
        _roles: []
    } : props.facility);

    const [locationState,setLocationState] = useState(typeof props.facility.id === 'undefined' ? {
        selected: {
            id: '',
            index: '',
        },
        activeQuery: false,
        value: '',                      // value of input field
        isOpen: false
    } : {
        selected: {
            id: props.facility.location_id,
            index: '',
        },
        activeQuery: false,
        value: props.locations[props.facility.location_id].name,                      // value of input field
        isOpen: false
    });

    const [slotsCount,setSlotsCount] = useState(typeof props.facility.facility_slots === 'undefined' ? '0' : '' + props.facility.facility_slots.length);
    const [slotChange,setSlotChange] = useState(0);
    const [image, setImage] = useState(facility.image);
    const [init, setInit] = useState(false);
    const [itemState,setItemState] = useState('init');                                  // init, saving
    const [createLockVisible, setCreateLockVisible] = useState(false);
    const [createLockPending, setCreateLockPending] = useState(false);
    const lockTexts = {true:t('close create lock'),false:t('show create lock')};
    const [lockVisibleButtonText, setLockVisibleButtonText] = useState(lockTexts[false]);
    const [boxGroupId, setBoxGroupId] = useState('');
    const [lockerId, setLockerId] = useState('');
    const _facility = useSelector(state => state.facilities.facility);                               // used for after save process
    const _facilities = useSelector(state => state.facilities.facilities);
    const _createLock = useSelector(state => state.paketins_data.createLock);

    const [notification,setNotification] = useState({
        message: "",
        show: false
    });

    // check for saving process
    if (itemState == 'saving') {
        // save process has been triggered
        if (props.facility.id !== undefined && props.facility.id != null && props.facility.id != '') {
            // edited item has been saved -> set slots
            // -> set slots

            if (slotChange > 0) {
                props.dispatch(facilitySlotActions.addFacilitySlot({
                    body: {
                        facility_id: Number(facility.id),
                        status: 'active',
                        all_roles: true
                    },
                    token: Biscuit.get('token') 
                }));
                setSlotChange(slotChange - 1);
            }
            else if (slotChange < 0 && facility.facility_slots.length+slotChange >= 0) {            // slotChange is negative!
                props.dispatch(facilitySlotActions.deleteFacilitySlot(
                    { 
                        id: Number(facility.facility_slots[facility.facility_slots.length+slotChange].id),
                        token: Biscuit.get('token')
                    }
                ));
                setSlotChange(slotChange + 1);
            }
            else if (slotChange == 0) {
                //setTimeout(function () {
                //    abortButtonRef.current.click();
                //},500);         // this delay is necessary because the button has not been rendered yet and for now there is not way to check for api success
            }
        }
        else if (document.location.href.indexOf('add') > 0) {
            //setTimeout(function () {
            //    if (abortButtonRef.current !== undefined && abortButtonRef.current != null) abortButtonRef.current.click();
            //},500);         // use a bigger delay for closing the task because it's not sure if the new task has been already saved yet
        }
    }
    useEffect(() => {
        if(image===''){
            return;
        }
        let clone = {};
        Object.assign(clone,facility);
        clone.image=image;
        setFacility(clone);
    },[image])


    useEffect(() => {

        if (_facilities.success === "") {            // true or false no matter if a new task is created or an existing task modified
          return;
        }
    
        if (itemState !== 'saving') return;

        var isNewTask = (document.location.href.indexOf('add') >= 0);

        if (_facility.success === true) {
    
          // show message "saved successful"
          props.showNotification('success', _facility.data.id,null,'facility');
        }
    
        if (_facility.success === false) {
          // show message "error during save"
          props.showNotification('warning', _facility.data.id,null,'facility');
        }

        if (_facilities.success === true && isNewTask) {
            props.showNotification('success', _facilities.data[_facilities.data.length-1].id,null,'facility');
        }

        if (_facilities.success === false && isNewTask) {
            props.showNotification('warning', null,(typeof _facilities.data.message !== 'undefined'?_facilities.data.message:null),'facility');
        }
        // close window
        abortButtonRef.current.click();
    }, [_facilities]);

   useEffect(() => {
      if(init || facility.roles === null) return;
      const ent = {};
      Object.assign(ent,facility);
      ent._roles = ent.roles.split(',');
      setFacility(ent);
      setInit(true);
   },[]);

   useEffect(() => {
        if(_createLock.success === '' || !createLockPending){
           return;
        }
        if(_createLock.success === true){
            let clone = {};
            Object.assign(clone, facility);
            clone.external_id = _createLock.data.localId;
            setFacility(clone);
            setCreateLockVisible(false);
            setLockVisibleButtonText(lockTexts[false]);
        }
        setCreateLockPending(false);

    },[_createLock]);

    const closeNotification = () => {

        setNotification({
            ...notification,
            show: false
        });
    };

    const onChangeImage = (e) => {
        let clone = {};
        Object.assign(clone, facility);
        clone.image = e.target.value;
        setImage(e.target.value);
        setFacility(clone);
    }

    const openLocationSelectHandle = (open) => {

        setLocationState({
            ...locationState,
            isOpen: open
        });
    };

    const locationSelectHandle = (id,index) => {

        if (id == '') {
            // reset selection
            setLocationState({
                selected: {
                    id: '',
                    index: '',
                },
                activeQuery: false,
                value: '',
                isOpen: false
            });
            return;
        }

        setLocationState({
            selected: {
                id: id,
                index: index,
            },
            activeQuery: false,
            value: props.locations[id].name,
            isOpen: false
        });
        setFacility({
            ...facility,
            location_id: id
        });
    };

    const queryLocationSelectHandle = (e) => {

        const val = e.target.value;

        // filter local data by query (only if query <= 2)
        setLocationState({
            ...locationState,
            value: val
        });

        // query for location
        if (val.length > 2) {

            setLocationState({
                ...locationState,
                value: val,
                activeQuery: true
            })

            props.dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                filter: {
                    'findForSelect' : true,                     // this is important to avoid loading all location data, only attributes for user selection are necessary
                    'q': val
                }
            }));
        }
    }

    const onChangeStatusHandle = (e) => {

        setFacility({
            ...facility,
            status: "" + e.target.value
        });
    };

    const onChangeSlotsCountHandle = (e) => {

        setSlotChange(Number(e.target.value) - slotsCount);
        setSlotsCount(e.target.value);
    };

    const onBlurSlotsCountHandle = () => {

        var val = Number(slotsCount);

        if (val != NaN && val > 0) {
        } else {
            setNotification({
                message: 'Anzahl Ladestationen muss eine positive Ganzzahl sein. Es muss mindestens eine Ladestation geben.',
                show: true
            });
        }
    };

    const onSubmit = () => {
        const entity = {};
        Object.assign(entity,facility);
        console.log(entity);
        // save facility and then add / change slots
        props.dispatch(facilityActions.resetFacility());
        if(facility._roles.length > 0){
            entity.roles = facility._roles.join(',');
            delete entity._roles;
        }
        if (typeof entity.id !== 'undefined' && entity.id != null) {

            props.dispatch(facilityActions.editFacility({
                id: Number(entity.id),
                body: entity,
                token: Biscuit.get('token') 
            }));
        }
        else {
            for (var i=0;i<slotsCount;i++) {
                entity.facility_slots.push({
                    status: 'active',
                    errorCode: null,
                    errorText: null
                });
            }
            props.dispatch(facilityActions.addFacility({
                body: entity,
                token: Biscuit.get('token') 
            }));
        }
        setItemState('saving');
    };
    const onChangeForm = (e) => {
        let clone = {};
        Object.assign(clone, facility);
        switch (e.target.name) {
            case 'name':
                clone.name = e.target.value;
                break;
            case 'description':
                clone.description = e.target.value;
                break;
            case 'facility_type':
                clone.facility_type = e.target.value;
                break;
            case 'booking_type':
                clone.booking_type = e.target.value;
                break;
            case 'external_id':
                clone.external_id = e.target.value;
                break;
            case 'hash':
                clone.hash = e.target.value;
                break;
            case 'autoCheckout':
                clone.autoCheckout = e.target.checked;
                break;
            case 'checkoutOutOfSlotPossible':
                clone.checkoutOutOfSlotPossible = e.target.checked;
                break;
        }
        setFacility(clone);             // set object state
    };

    const onChangeLock = (e) => {
        switch (e.target.name) {
            case 'boxGroupId':
                setBoxGroupId(e.target.value);
                break;
            case 'lockerId':
                setLockerId(e.target.value);
        }
    }

    const onCreateLock = () => {
         if(boxGroupId !== '' && lockerId !== ''){
            props.dispatch(paketinActions.createLock({
                token: Biscuit.get('token'),
                data: {
                    boxId: boxGroupId,
                    resourceId: lockerId
                }
            }));
            setCreateLockPending(true);
         }


    }

    const onChangeHandler = (id) =>
    {
        let clone = {};
        Object.assign(clone,facility);
        clone._roles.push(id);
        setFacility(clone);
    }
    const onCreateLockShow = () => {
        const toSet = !createLockVisible;
        setCreateLockVisible(toSet);
        setLockVisibleButtonText(lockTexts[toSet]);
    }

    const abortButtonRef = React.createRef();

    return (
        <>
        <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
        {notification.show &&
        <>
            <Notification
            message={notification.message}
            close={closeNotification}>
            </Notification>
        </>
        }
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" aria-hidden="false">
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                <h1 className="inb-page-title">{(typeof props.facility.id !== 'undefined' && props.facility.id != '') ? t('edit_${a}',{a:t(_exchangeLabel('facility'))},'capital') : t('add_${a}',{a:t(_exchangeLabel('facility'))})}</h1>
                <div className="off-canvas__actions column">
                    <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title="Speichern" onClick={onSubmit}>
                    {itemState == 'init' &&
                        <>
                          <i className="fi fi-check"></i>
                          <span>{t('save')}</span>
                        </>
                        }
                        {itemState == 'saving' &&
                          <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                        }
                    </button>
                    <a
                        href="/facilities">
                        <button ref={abortButtonRef} type="button" id="inb-facilities-form-abort-button" className="button hollow secondary right button-abort round" title="Fenster schließen" onClick={props.onClose}>
                            <i className="fi fi-x"></i>
                        </button>
                    </a>
                </div>
            </header>
            <p className="off-canvas__subtitle off-canvas__header-region">
                {typeof facility.created !== 'undefined' &&
                t('created_at') + " " + facility.created + " " + t('edited_by') + " " + props.getUserNameById(facility.created_by) + " | " + t('last_modified_at') + " " + facility.modified + " " + t('edited_by') + " " + props.getUserNameById(facility.modified_by)
                }
            </p>
            <form className="off-content row">

            <div className="inb-form-group column medium-3 small-12 lang">
                    <label className="inb-form__controlLabel">Standort</label>
                    <div className="inb-form__controllClass">
                        <div className={"inbooma-select-box" + (locationState.isOpen ? '' : ' close')}>
                            {locationState.selected.id == '' &&
                                <input className="inbooma-select-box__input" placeholder="Standort wählen" value={locationState.value}
                                onClick={() => {openLocationSelectHandle(true)}}
                                onBlur={() => {openLocationSelectHandle(false)}}
                                onChange={(e) => {queryLocationSelectHandle(e)}} />
                            }
                            {locationState.selected.id != '' &&
                                <input className="inbooma-select-box__input" placeholder="Standort wählen" value={locationState.value} readOnly
                                style={{background: '#fff',border: '1px solid #e3e3e3',padding: '0.5rem',fontSize: '0.9rem',color: '#3b3b3b'}}
                                onClick={() => {openLocationSelectHandle(true)}}
                                onBlur={() => {openLocationSelectHandle(false)}}
                                onChange={(e) => {queryLocationSelectHandle(e)}} />
                            }
                            {locationState.selected.id != '' &&
                                <a href="#" className="inbooma-select-box__reset" onClick={() => locationSelectHandle('','')}>
                                x
                                </a>
                            }
                            {((locationState.activeQuery && locationState.value.length <= 2) || !locationState.activeQuery) &&
                            <ul className={"inbooma-select-box-results" + (locationState.isOpen ? '' : ' hidden')}>
                                {Object.keys(props.locations).map((id,index) => {
                                    return (
                                    <li className={"inbooma-select-box-results__field" + (locationState.selected.id == id ? ' selected' : '')}
                                        key={id} value={id} 
                                        onClick={() => { locationSelectHandle(id,index) }}>
                                            {props.locations[id].name}
                                    </li>
                                    );
                                })}
                            </ul>}
                            {locationState.activeQuery && locationState.value.length > 2 &&
                            <ul className={"inbooma-select-box-results" + (locationState.isOpen ? '' : ' hidden')}>
                            {Object.keys(props.locations).map((id,index) => {
                                return (
                                <li className={"inbooma-select-box-results__field" + (locationState.selected.id == id ? ' selected' : '')}
                                    key={id} value={id} 
                                    onClick={() => { locationSelectHandle(id,index) }}>
                                        {props.locations[id].name}
                                </li>
                                );
                            })}
                            </ul>}
                        </div>
                    </div>
                </div>
                <div className="inb-form-group column medium-6 small-12 facility_type">
                    <label className="inb-form__controlLabel">{t('facility_type')}</label>
                    <div className="inb-form__controllClass">
                        <select className="form-control" name="facility_type" value={facility.facility_type} disabled={(Biscuit.get('user.is_superuser') !== 'true')} onChange={(e) => {onChangeForm(e)}}>
                            {['cyclepoint','general_paketin_admin','general_paketin_pin'].map(facilityType => {
                                if(facilityType === null){
                                    facilityType = 'cyclepoint';
                                }
                                return (
                                    <>
                                    {facility.facility_type === facilityType ? <option value={facilityType} selected={true}>{t(facilityType)}</option> : <option value={facilityType}>{t(facilityType)}</option>}
                                    </>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="inb-form-group column medium-6 small-12 booking_type">
                    <label className="inb-form__controlLabel">{t('booking_type')}</label>
                    <div className="inb-form__controllClass">
                        <select className="form-control" name="booking_type" value={facility.booking_type} disabled={(Biscuit.get('user.is_superuser') !== 'true')} onChange={(e) => {onChangeForm(e)}}>
                            {['none','contingent'].map(bookingType => {
                                return (
                                    <>
                                        {facility.booking_type === bookingType ? <option value={bookingType} selected={true}>{t(bookingType)}</option> : <option value={bookingType}>{t(bookingType)}</option>}
                                    </>
                                )
                            })}
                        </select>
                    </div>
                </div>

                <div className="inb-form-group column medium-6 small-12 status">
                    <label className="inb-form__controlLabel">Status</label>
                    <div className="inb-form__controllClass">
                        <select className="form-control" name="status" value={facility.status} onChange={(e) => {onChangeStatusHandle(e)}}>
                           <option value="active">Aktiv</option>
                            <option value="inactive">Inaktiv</option>
                        </select>
                    </div>
                </div>
                {facility.facility_type === 'cyclepoint' && <><div className="inb-form-group column medium-12 small-12 number_slots">
                    <label className="inb-form__controlLabel">Anzahl Ladestationen</label>
                    <div className="inb-form__controllClass">
                        <input type="text" className="form-control" name="number_slots" autoComplete="false" maxLength="255" value={slotsCount} placeholder="" required=""
                                onChange={(e) => {onChangeSlotsCountHandle(e)}} onBlur={() => {onBlurSlotsCountHandle()}}/>
                    </div>
                </div>
                    {Biscuit.get('client.autoCheckout') === 'true' && <FormItem
                    name="autoCheckout"
                    type="checkbox"
                    id={"facility_autoCheckout_"+(typeof facility.id !== 'undefined'?facility.id:'new')}
                    label="Automatischer Checkout beim Einstellen"
                    labelStyle={{}}
                    htmlFor={""}
                    value={facility.autoCheckout}
                    mediumWidth={6}
                    smallWidth={12}
                    switchStyle={{clear:'both'}}
                    disabled={''}
                    onChangeHandler={onChangeForm}
                    extraTopClasses=""/>}

                    <FormItem
                                name="checkoutOutOfSlotPossible"
                                type="checkbox"
                                id={"facility_checkoutOutOfSlotPossible_"+(typeof facility.id !== 'undefined'?facility.id:'new')}
                                label="Abgabe neben der Anlage möglich"
                                labelStyle={{}}
                                htmlFor={""}
                                value={facility.checkoutOutOfSlotPossible}
                                mediumWidth={6}
                                smallWidth={12}
                                switchStyle={{clear:'both'}}
                                disabled={''}
                                onChangeHandler={onChangeForm}
                                extraTopClasses=""/>


                    </>
                }
                {facility.facility_type !== 'cyclepoint' &&
                    <>
                        <div className="inb-form-group column medium-6 small-12 name">
                            <label className="inb-form__controlLabel">{t('name')}</label>
                            <div className="inb-form__controllClass">
                                <input type="text" className="form-control" name="name" autoComplete="false" value={facility.name} placeholder="" required=""
                                       onChange={(e) => {onChangeForm(e)}}/>
                            </div>
                        </div>
                        <div className="inb-form-group column medium-6 small-12 description">
                            <label className="inb-form__controlLabel">{t('description')}</label>
                            <div className="inb-form__controllClass">
                                <input type="text" className="form-control" name="description" autoComplete="false" value={facility.description} placeholder="" required=""
                                       onChange={(e) => {onChangeForm(e)}}/>
                            </div>
                        </div>
                        <ImageUpload
                            onChange={onChangeImage}
                            image={facility.image}
                            type='facility'
                            clientId={Biscuit.get('user.client_id')}
                            setImage={setImage}
                            dispatch={props.dispatch}
                        />
                        {false && init && <FormItem
                            type="select2"
                            label={t('roles')}
                            placeholder={t('please change')}
                            data={[
                                {
                                    "id" : "user",
                                    "name": t('user')
                                },
                                {
                                    "id": "manager",
                                    "name": t("manager")
                                },
                                {
                                    "id" : "admin",
                                    "name": t('admin')
                                },
                                {
                                    "id": "garage-staff",
                                    "name": t("garage-staff")
                                },
                                {
                                    "id" : "manager-location",
                                    "name": t('manager-location')
                                },
                                {
                                    "id": "booking-manager",
                                    "name": t("booking-manager")
                                },
                                {
                                    "id" : "guide",
                                    "name": t('guide')
                                },
                                {
                                    "id": "mediator",
                                    "name": t("mediator")
                                },
                                {
                                    "id": "facility-service",
                                    "name": t("facility-service")
                                }
                            ]}
                            nameAttribute="name"
                            onChangeHandle={onChangeHandler}
                            dataKey="id"
                            value={facility._roles}
                            mediumWidth="6"
                            smallWidth="12"
                            />}
                        {Biscuit.get('user.is_superuser') === 'true' && facility.facility_type !== 'cyclepoint' &&
                        <>
                            <div className="inb-form-group column medium-6 small-12 name">
                                <label className="inb-form__controlLabel">{t('external_id')}</label>
                                <div className="inb-form__controllClass">
                                    <input type="text" className="form-control" name="external_id" autoComplete="false" value={facility.external_id} placeholder="" required=""
                                           onChange={(e) => {onChangeForm(e)}}/>
                                </div>
                            </div>
                            <div className="inb-form-group column medium-6 small-12 description">
                                <label className="inb-form__controlLabel">{t('hash')}</label>
                                <div className="inb-form__controllClass">
                                    <input type="text" className="form-control" name="hash" autoComplete="false" value={facility.hash} placeholder="" required=""
                                           onChange={(e) => {onChangeForm(e)}}/>
                                </div>
                            </div>
                            <div className="inb-form-group column large-12 medium-12 small-12 float-left">
                                <div className="column large-5 medium-4 small-3 float-left" style={{minWidth:"33%"}}> &nbsp;</div>
                                <div className="column large-2 medium-3 small-4 float-left" style={{minWidth:"33%"}}>
                                    <div className="medium-4 small-12 column" title={t('user',null,'capital')} style={{minWidth:'100%'}}>
                                        <a className={"button beautify beautify-" + Biscuit.get('user.client_id')} href="#" onClick={onCreateLockShow}><i className="fi fi-page-add"></i>
                                            <span>{lockVisibleButtonText}</span></a>
                                    </div>
                                </div>
                                <div className="column large-5 medium-4 small-3 float-left" style={{minWidth:"33%"}}> &nbsp;</div>
                            </div>
                                {createLockVisible && <>
                                <div className="inb-form-group column large-12 medium-12 small-12 float-left">
                                    <div className="inb-form-group column large-3 medium-4 small-4 float-left" style={{minWidth:"33%"}}>
                                        <label className="inb-form__controlLabel">{t('boxGroupId')}</label>
                                        <div className="inb-form__controllClass">
                                            <input type="text" className="form-control" name="boxGroupId" autoComplete="false" value={boxGroupId} placeholder="" required=""
                                                   onChange={(e) => {onChangeLock(e)}}/>
                                        </div>
                                    </div>
                                    <div className="inb-form-group column large-3 medium-4 small-4 float-left" style={{minWidth:"33%"}}>
                                        <label className="inb-form__controlLabel">{t('lockerId')}</label>
                                        <div className="inb-form__controllClass">
                                            <input type="text" className="form-control" name="lockerId" autoComplete="false" value={lockerId} placeholder="" required=""
                                                   onChange={(e) => {onChangeLock(e)}}/>
                                        </div>
                                    </div>
                                    <div className="column large-2 medium-3 small-4 float-left" style={{minWidth:"33%"}}>
                                        <div className="medium-4 small-12 column" title={t('user',null,'capital')} style={{minWidth:'100%',paadingTop:'10px'}}>
                                            <a className={"button beautify beautify-" + Biscuit.get('user.client_id')} href="#" onClick={onCreateLock}><i className="fi fi-page-add"></i>
                                                <span>{t('create lock')}</span></a>
                                        </div>
                                    </div>
                                </div>
                                </>}
                        </>}
                    </>
                }
            </form>
        </div>
        </>
    );
};

export default FacilityView;